<form [formGroup]="searchForm" (ngSubmit)="onFormSubmit()">
    <div class="container-form">
        <div class="field-container">
            <mat-form-field class="field">
                <mat-label>{{ 'certificates.eikCurrentAgent' | translate }}</mat-label>
                <input matInput formControlName="vat" readonly class="disabled">
            </mat-form-field>

            <mat-form-field class="field">
                <mat-label>{{ 'certificates.certType' | translate }}</mat-label>
                <mat-select formControlName="type" multiple>
                    <mat-option *ngFor="let type of typeOfCertificates" [value]="type.value">
                        <div class="truncate">{{ type.name | translate }}</div>
                    </mat-option>
                </mat-select>
                <button *ngIf="searchForm.get('type')?.value" matSuffix mat-icon-button (click)="clearField('type')">
                    <cqes-icon icon="close"></cqes-icon>
                </button>
            </mat-form-field>

            <mat-form-field class="field">
                <mat-label>{{ 'certificates.status' | translate }}</mat-label>
                <mat-select formControlName="status" multiple>
                    <mat-option *ngFor="let status of certificateStatuses" [value]="status.value">
                        {{ status.name }}
                    </mat-option>
                </mat-select>
                <button *ngIf="searchForm.get('status')?.value" matSuffix mat-icon-button
                    (click)="clearField('status')">
                    <cqes-icon icon="close"></cqes-icon>
                </button>
            </mat-form-field>

            <mat-form-field class="field">
                <mat-label>{{ 'certificates.serialNumber' | translate }}</mat-label>
                <input matInput formControlName="serialNumber">
                <button *ngIf="searchForm.get('serialNumber')?.value" matSuffix mat-icon-button
                    (click)="clearField('serialNumber')">
                    <cqes-icon icon="close"></cqes-icon>
                </button>
            </mat-form-field>

            <mat-form-field class="field">
                <mat-label>{{ 'certificates.clientName' | translate }}</mat-label>
                <input matInput formControlName="clientName">
                <button *ngIf="searchForm.get('clientName')?.value" matSuffix mat-icon-button
                    (click)="clearField('clientName')">
                    <cqes-icon icon="close"></cqes-icon>
                </button>
            </mat-form-field>

            <mat-form-field class="field">
                <mat-label>{{ 'certificates.clientIdentification' | translate }}</mat-label>
                <input matInput formControlName="clientIdentification">
                <button *ngIf="searchForm.get('clientIdentification')?.value" matSuffix mat-icon-button
                    (click)="clearField('clientIdentification')">
                    <cqes-icon icon="close"></cqes-icon>
                </button>
            </mat-form-field>
        </div>

        <div class="row-search">
            <mat-form-field class="line">
                <mat-label>{{ 'certificates.fromValidityDate' | translate }}</mat-label>
                <input matInput [matDatepicker]="fromStartDate" formControlName="fromStartDate"
                    [max]="fromStartDateMax">
                <mat-datepicker-toggle matSuffix [for]="fromStartDate"></mat-datepicker-toggle>
                <button *ngIf="searchForm.get('fromStartDate')?.value" matSuffix mat-icon-button
                    (click)="clearField('fromStartDate')">
                    <cqes-icon icon="close"></cqes-icon>
                </button>
                <mat-datepicker #fromStartDate></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="line">
                <mat-label>{{ 'certificates.untilExpirationDate' | translate }}</mat-label>
                <input matInput [matDatepicker]="toStartDate" formControlName="toStartDate" [min]="toStartDateMin">
                <mat-datepicker-toggle matSuffix [for]="toStartDate"></mat-datepicker-toggle>
                <button *ngIf="searchForm.get('toStartDate')?.value" matSuffix mat-icon-button
                    (click)="clearField('toStartDate')">
                    <cqes-icon icon="close"></cqes-icon>
                </button>
                <mat-datepicker #toStartDate></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="row-search">
            <mat-form-field class="line">
                <mat-label>{{ 'certificates.expiringStartDate' | translate }}</mat-label>
                <input matInput [matDatepicker]="fromExpiryDate" formControlName="fromExpiryDate"
                    [max]="fromExpiryDateMax">
                <mat-datepicker-toggle matSuffix [for]="fromExpiryDate"></mat-datepicker-toggle>
                <button *ngIf="searchForm.get('fromExpiryDate')?.value" matSuffix mat-icon-button
                    (click)="clearField('fromExpiryDate')">
                    <cqes-icon icon="close"></cqes-icon>
                </button>
                <mat-datepicker #fromExpiryDate></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="line">
                <mat-label>{{ 'certificates.expiringEndDate' | translate }}</mat-label>
                <input matInput [matDatepicker]="toExpiryDate" formControlName="toExpiryDate" [min]="toExpiryDateMin">
                <mat-datepicker-toggle matSuffix [for]="toExpiryDate"></mat-datepicker-toggle>
                <button *ngIf="searchForm.get('toExpiryDate')?.value" matSuffix mat-icon-button
                    (click)="clearField('toExpiryDate')">
                    <cqes-icon icon="close"></cqes-icon>
                </button>
                <mat-datepicker #toExpiryDate></mat-datepicker>
            </mat-form-field>
        </div>
        <!-- </div> -->
    </div>
    <div class="action-buttons">
        <button mat-button type="submit" class="mat-mdc-raised-button">{{ 'certificates.searchCertificates' |
            translate }}</button>
        <button mat-button (click)="resetFilters()" type="button" class="mat-mdc-raised-button">{{
            'certificates.resetFilters' | translate
            }}</button>
        <button mat-button (click)="exportExcel()" [disabled]="!hasData()" type="button"
            class="mat-mdc-raised-button">{{
            'certificates.exportExcel' | translate }}</button>
    </div>
</form>
<div class="no-content-message">
    {{this.emptyMassage}}
</div>
<div class="spinner-container" *ngIf="!showTable && loading">
    <mat-spinner class="content-box"></mat-spinner>
</div>
<cloud-business-hardware-certificates-table *ngIf="showTable" [hardwareCertificates]="hardwareCertificates"
    [loading]="loading" [totalCount]="totalCount" [pageSize]="currentPagination.pageSize"
    [pageIndex]="currentPagination.pageIndex" (pageChange)="onPageChange($event)" (sortChange)="onSortChange($event)">
</cloud-business-hardware-certificates-table>